import styled from "styled-components";
import { colors, screenSizes, typography } from "@streeteasy/design-system";
import XButtonBase from "@streeteasy/design-system/deprecated/XButton";

import MODAL_VIEW_TYPES from "../../constants/modalViewTypes";
import AgentCardBase from "../AgentCard";
import { ButtonContainer, CancelButton } from "../AgentContactForm/styled";
import FormHeaderBase from "../FormHeader";
import { SubTitle, Title } from "../FormHeader/styled";

const { BRAND_DARKEST, GRAY_LIGHT, WHITE } = colors;

const { LARGE_SCREEN } = screenSizes;
const modalPadding = "64px";
const modalPaddingMobile = "38px";

export const ModalContent = styled.div`
  overflow: scroll;
  padding: ${modalPadding} ${modalPadding} 0;
  position: relative;
  width: 100%;

  ${ButtonContainer} {
    margin-left: -${modalPadding};
    margin-right: -${modalPadding};
    padding-left: ${modalPadding};
    padding-right: ${modalPadding};

    @media screen and (max-width: ${LARGE_SCREEN}px) {
      margin-left: -${modalPaddingMobile};
      margin-right: -${modalPaddingMobile};
      padding-left: ${modalPaddingMobile};
      padding-right: ${modalPaddingMobile};
    }
  }

  ${CancelButton} {
    @media screen and (max-width: ${LARGE_SCREEN}px) {
      display: none;
    }
  }

  ${Title} {
    @media screen and (max-width: ${LARGE_SCREEN}px) {
      align-items: center;
      background-color: ${BRAND_DARKEST};
      color: ${WHITE};
      display: flex;
      font-size: 16px;
      font-weight: 600;
      height: 57px;
      justify-content: center;
      line-height: 24px;
      margin: -${modalPaddingMobile} -${modalPaddingMobile} 24px -${modalPaddingMobile};
      position: absolute;
      width: 100%;
      z-index: 2;
    }
  }

  ${SubTitle} {
    @media screen and (max-width: ${LARGE_SCREEN}px) {
      padding-top: 44px;
    }
  }

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    padding: ${modalPaddingMobile} ${modalPaddingMobile} 0;
  }
`;

export const FormHeader = styled(FormHeaderBase)`
  border-bottom: 1px solid ${GRAY_LIGHT};
  margin-bottom: 16px;
  padding-bottom: 16px;
`;

export const AgentCard = styled(AgentCardBase)`
  margin-bottom: 16px;
`;

export const XButton = styled(XButtonBase)`
  position: absolute;
  right: 21px;
  top: 21px;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    ${({ modalViewType }) =>
      modalViewType === MODAL_VIEW_TYPES.agentContact &&
      `
      &:after,
      &:before {
        background-color: ${WHITE};
      }
    `}
  }
`;

export const MessageContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;

export const ContentContainer = styled.div`
  height: 100%;
`;

export const LoadingText = styled(typography.P)``;
